module.exports = __webpack_public_path__ + "static/media/a1.840f1b0e.jpg";